/** The keyboard shortcut sheet: `?` anywhere on a table page, or the keyboard button in the tools.
 *
 * One list, so a shortcut added to the grid is added here in the same diff; `ShortcutSheet.test.tsx`
 * asserts the sheet lists the keys the grid answers to. It is a dialog (`Drawer`) and so is not
 * counted as body text while it is closed.
 */

import { Drawer } from "../Drawer";
import { SHORTCUTS } from "./shortcuts";
import styles from "./tablePower.module.css";

export function ShortcutSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Drawer open={open} onClose={onClose} title="Keyboard shortcuts" width="sm" testId="shortcut-sheet">
      <dl className={styles.shortcuts}>
        {SHORTCUTS.map((shortcut) => (
          <div key={shortcut.keys} className={styles.shortcut}>
            <dt>
              <kbd>{shortcut.keys}</kbd>
            </dt>
            <dd>{shortcut.does}</dd>
          </div>
        ))}
      </dl>
    </Drawer>
  );
}
